module.exports = __webpack_public_path__ + "static/media/P20.36b6b7de.jpg";